import { useCurrentUser } from '@klp/auth';

import { FrontpageCardTypes } from '../utils';

export const useFrontpageCardsByRole = () => {
    const { currentUser } = useCurrentUser();

    // All cards that user can select from (always all 5 cards regardless of role)
    const getAllowedCards = (): Array<FrontpageCardTypes> => {
        return [
            FrontpageCardTypes.KONTRAKTER,
            FrontpageCardTypes.PROSJEKTER,
            FrontpageCardTypes.UTESTAAENDE_FORDRINGER,
            FrontpageCardTypes.AREALMESSIG_UTLEIEGRAD,
            FrontpageCardTypes.SAKER,
            FrontpageCardTypes.LEVERANDOR,
        ];
    };

    // Default cards shown when user hasn't made a manual selection (varies by role)
    const getDefaultCards = (): Array<FrontpageCardTypes> => {
        switch (true) {
            case currentUser?.isForvalter:
                return [
                    FrontpageCardTypes.KONTRAKTER,
                    FrontpageCardTypes.PROSJEKTER,
                    FrontpageCardTypes.UTESTAAENDE_FORDRINGER,
                    FrontpageCardTypes.AREALMESSIG_UTLEIEGRAD,
                    FrontpageCardTypes.SAKER,
                    FrontpageCardTypes.LEVERANDOR,
                ];
            case currentUser?.isDrift:
                return [
                    FrontpageCardTypes.KONTRAKTER,
                    FrontpageCardTypes.PROSJEKTER,
                    FrontpageCardTypes.UTESTAAENDE_FORDRINGER,
                    FrontpageCardTypes.AREALMESSIG_UTLEIEGRAD,
                    FrontpageCardTypes.SAKER,
                    FrontpageCardTypes.LEVERANDOR,
                ];
            case currentUser?.isOkonomi:
                return [
                    FrontpageCardTypes.KONTRAKTER,
                    FrontpageCardTypes.PROSJEKTER,
                    FrontpageCardTypes.SAKER,
                    FrontpageCardTypes.LEVERANDOR,
                ];
            default:
                return [
                    FrontpageCardTypes.KONTRAKTER,
                    FrontpageCardTypes.PROSJEKTER,
                    FrontpageCardTypes.UTESTAAENDE_FORDRINGER,
                    FrontpageCardTypes.AREALMESSIG_UTLEIEGRAD,
                    FrontpageCardTypes.SAKER,
                    FrontpageCardTypes.LEVERANDOR,
                ];
        }
    };

    return {
        allowedCards: getAllowedCards(),
        defaultCards: getDefaultCards(),
    };
};
